// action
import {
    GET_APPOINTMENT_HISTORY,
    GET_APPOINTMENT_HISTORY_FAIL,
    GET_APPOINTMENT_HISTORY_SUCCESS,
    GET_APPOINTMENT_HISTORY_RESET
} from '../action/getAppointmentHistoryAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    data: {},
    message: ""
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function(state = initialState, action) {
    switch (action.type) {
        case GET_APPOINTMENT_HISTORY:
            return {
                ...state,
                apiState: "loading"
            }
        case GET_APPOINTMENT_HISTORY_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case GET_APPOINTMENT_HISTORY_SUCCESS:
            console.log("In reducer");
            return {
                ...state,
                apiState: "success",
                data: action.response.data,
            }
        case GET_APPOINTMENT_HISTORY_RESET:
            return initialState
        default:
            return {
                ...state
            }
    }
}